import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import RowadLogo from './RowadLogo.js';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;
const navItems = ['My Account','My Tickets', 'Create Ticket', 'Logout'];

function Header(props) {
  const navigate = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const reloadPage = () => {
    Cookies.remove('token');
    navigate('/sign-in', { replace: true });
  };

  const drawer = (
    <>
 
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          <RowadLogo />
        </Typography>
        <Divider />
        <List>
          {navItems.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton sx={{ textAlign: 'center' }} onClick={() => {
                switch (item) {
                  case 'My Account':
                    navigate("/my-account");
                    break;
                  case 'My Tickets':
                    navigate("/");
                    break;
                  case 'Create Ticket':
                    navigate("/new-ticket");
                    break;
                  case 'Logout':
                    reloadPage();
                    break;
                  default:
                    break;
                }
              }}>
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
      <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar component="nav">
            <Toolbar>
            <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
            >
            <MenuIcon />
            </IconButton>
            <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
            <RowadLogo />
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'flex' }, flexDirection: 'row' }}>
                  <Button key={navItems[0]} sx={{ color: '#fff' }} onClick={() => navigate("/my-account")}>
                        {navItems[0]}
                      </Button>
                      <Button key={navItems[0]} sx={{ color: '#fff' }} onClick={() => navigate("/")}>
                        {navItems[1]}
                      </Button>
                      <Button key={navItems[2]} sx={{ color: '#fff' }} onClick={() => { 
                        navigate("/new-ticket")
                      }}>
                        {navItems[2]}
                      </Button>
                      <Button key={navItems[2]} sx={{ color: '#fff' }} 
                      onClick={reloadPage}>
                        {navItems[3]} 
                        </Button>
                
                  </Box>
                </Toolbar>
          </AppBar>
          <nav>
          <RowadLogo/>
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
            >
      
              {drawer}
            </Drawer>
          </nav>
          <Box component="main" sx={{ p: 3 }}>
            <Toolbar />
            {/* Main content can go here */}
          </Box>
      </Box>
  );
}

Header.propTypes = {
  window: PropTypes.func,
};

export default Header;